export const EXPERIMENTS = {
  USE_FIELDS_V2: 'specs.forms.UseFieldsV2',
  REMOVE_FLEXBOX: 'specs.forms.RemoveFlexbox',
  SUBMIT_STATUS_MESSAGE_VIEWER: 'specs.forms.SubmitStatusMessageViewer',
  USE_CUSTOM_ERROR_MESSAGES: 'specs.forms.UseCustomErrorMessages',
  USE_CSS_VARS_ONLY: 'specs.forms.UseCSSVarsOnly',
  ENABLE_SUBMIT_LIMITS_SETTINGS: 'specs.forms.EnableSubmitLimitsSettings',
  ENABLE_QUIZ_QUESTION_IMAGE: 'specs.forms.EnableQuizQuestionImage',
  REMOVE_PHONE_DEFAULT_VALUE: 'specs.forms.RemovePhoneDefaultValueComposer',
  FILE_UPLOAD_LIMIT_EXCEEDED: 'specs.forms.FileUploadLimitExceeded'
};
//# sourceMappingURL=experiments.js.map